export const RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES =
	'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';

export const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;
